<template>
  <div
    class="base-imagebox"
    :style="{ width: boxWidth, ...wrapStyle }"
  >
    <div
      class="base-imagebox__wrap"
    >
      <header class="base-imagebox__header">
        <el-tooltip
          :content="title"
          placement="top"
        >
          <span>{{ title }}</span>
        </el-tooltip>
      </header>
      <main class="base-imagebox__body">
        <div class="base-imagebox__inner">
          <base-image v-bind="$attrs" :src="img" />
        </div>
        <div class="base-imagebox__desc">
          <slot>
            <base-label :label="label">{{ desc }}</base-label>
          </slot>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseImagebox',

  inheritAttrs: false,

  props: {
    title: String,
    img: String,
    label: String,
    desc: String,
    width: [ String, Number ],
    gutter: {
      type: Number,
      default: 0
    }
  },

  computed: {
    boxWidth () {
      return /^\d+(\.\d+)?$/.test(String(this.width)) ? `${this.width}px` : this.width
    },
    wrapStyle () {
      if (this.gutter > 0) {
        const padding = Math.floor(this.gutter / 2) + 'px'
        return {
          padding: `0 ${padding} ${padding}`
        }
      }
      return {}
    }
  }
}
</script>

<style lang="scss">
  .base-imagebox {
    display: inline-block;
    width: 100%;
    height: 25%;
    .base-imagebox__wrap {
      position: relative;
      height: 100%;
      border: 1px solid $--border-color-light-1;
      border-radius: 2px;
    }
    .base-imagebox__header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 0 20px;
      width: 100%;
      height: 37px;
      line-height: 37px;
      background-color: #f8f8f8;
      text-align: center;
      font-size: 13px;
      @include ellipsis;
      z-index: 2;
    }
    .base-imagebox__body {
      padding: 47px 20px 10px;
      height: 100%;
      overflow: auto;
    }
    .base-imagebox__inner {
      margin-bottom: 10px;
      width: 100%;
      height: 150px;
      border-radius: 4px;
      overflow: hidden;
      text-align: center;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .base-imagebox__desc {
      color: $--color-text-primary;
      font-size: 12px;
    }
  }
</style>
